import {
  PROPOSE_EDIT, PROPOSE_EDIT_FAILURE, PROPOSE_EDIT_SUCCESS, PROPOSE_UPDATE, PROPOSE_UPDATE_FAILURE, PROPOSE_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    propose: null,
    joint_1_user: null,
    joint_2_user: null
  },
  getters: {
    editProposeDetail: state => {
      return state.propose
    },
    editJoint1User: state => {
      return state.joint_1_user
    },
    editJoint2User: state => {
      return state.joint_2_user
    }
  },
  actions: {
    [PROPOSE_EDIT] ({dispatch, state, commit}, params = null) {
      var url = '/asovi/proposes/' + params.id + '/edit'
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_EDIT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_EDIT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/asovi/proposes/' + params.id, data: data, noneedloading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_UPDATE_FAILURE, res.data)
          } else {
            commit(PROPOSE_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_EDIT_FAILURE] (state, data) {
      console.log('PROPOSE_EDIT_FAILURE')
    },
    [PROPOSE_EDIT_SUCCESS] (state, data) {
      console.log('PROPOSE_EDIT_SUCCESS')
      state.propose = data.propose.data
      state.joint_1_user = data.joint_1_user ? data.joint_1_user.data : null
      state.joint_2_user = data.joint_2_user ? data.joint_2_user.data : null
      if (data.callback) {
        data.callback()
      }
    },
    [PROPOSE_UPDATE_FAILURE] (state, data) {
      console.log('PROPOSE_UPDATE_FAILURE')
    },
    [PROPOSE_UPDATE_SUCCESS] (state, data) {
      console.log('PROPOSE_UPDATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-edit.js